import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  kind: 'success' | 'error' | 'info';
  message: string;
  detail?: string;
}

/** Bottom-center toast notifications (replaces PrimeNG MessageService). */
@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toasts = signal<Toast[]>([]);
  private seq = 0;

  success(message: string, detail?: string): void {
    this.push('success', message, detail);
  }

  error(message: string, detail?: string): void {
    this.push('error', message, detail, 6000);
  }

  info(message: string, detail?: string): void {
    this.push('info', message, detail);
  }

  private push(kind: Toast['kind'], message: string, detail?: string, life = 3200): void {
    const toast: Toast = { id: ++this.seq, kind, message, detail };
    this.toasts.update((list) => [...list, toast]);
    setTimeout(() => this.dismiss(toast.id), life);
  }

  dismiss(id: number): void {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }
}
